import { Component, Inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'request-changes-dialog',
  templateUrl: './request-changes-dialog.component.html',
  standalone: false,
})
export class RequestChangesDialogComponent {
  protected details = '';
  protected editorName = signal('');

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: { reviewRequestedBy: string },
  ) {
    this.editorName.set(this.data.reviewRequestedBy);
  }

  protected get result() {
    return {
      notes: this.details,
    };
  }
}
